import {
  getAppLang, getSelectedQuiz, defaultLang, setAppLang, setSelectedQuiz,
} from '@/utils/cookie-helper';

const types = {
  SET_DRAWER_STATE: 'SET_DRAWER_STATE',
  SET_LANG: 'SET_LANG',
  SET_SELECTED_QUIZ: 'SET_SELECTED_QUIZ',
};

const state = {
  drawerState: false,
  lang: getAppLang() || defaultLang(),
  selectedQuiz: getSelectedQuiz() || null,
};

const getters = {
  getDrawerState: (state) => state.drawerState,
  getLang: (state) => state.lang,
  getSelectedQuiz: (state) => state.selectedQuiz,
};

const mutations = {
  [types.SET_DRAWER_STATE](state, value) {
    state.drawerState = value;
  },
  [types.SET_LANG](state, lang) {
    state.lang = lang;
  },
  [types.SET_SELECTED_QUIZ](state, quiz) {
    state.selectedQuiz = quiz;
  },
};

const actions = {
  setDrawerState({ commit }, value) {
    commit(types.SET_DRAWER_STATE, value);
  },
  setLang({ commit }, { lang }) {
    commit(types.SET_LANG, lang);
    setAppLang(lang);
  },
  setSelectedQuiz({ commit }, { quiz }) {
    commit(types.SET_SELECTED_QUIZ, quiz);
    setSelectedQuiz(quiz);
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
